export default __webpack_public_path__ + "static/media/404-mobile.0f606f53.svg";